<template>
    <div style="width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}">
      <model-viewer
          autoplay
          ref="modelViewer"
          auto-rotate="true"
          camera-controls
          interaction-prompt="none"
          :src="baseUrl + name"
          ar-status="not-presenting"
          style="width: 100%; height: 85vh;">
      </model-viewer>
    </div>
</template>
<script>
import '@google/model-viewer/lib/model-viewer.js';

export default {
  name: "threeAuto",
  components: {
  },
  data() {
    return {
      name: '',
      baseUrl: "http://jqsj-beijing.oss-cn-beijing.aliyuncs.com/jiuqishujie-file/",
    }
  },
  mounted() {
    this.init()
    this.addEventListeners();
    // this.$refs.modelViewer.addEventListener('load', this.onModelLoad);  autoplay
    // 选择你的 <model-viewer> 元素
  },
  beforeDestroy() {
    this.removeEventListeners();
  },
  methods: {
    addEventListeners() {
      const modelViewer = this.$refs.modelViewer;
      modelViewer.addEventListener('touchmove', this.preventScroll, { passive: false });
      modelViewer.addEventListener('wheel', this.preventScroll, { passive: false });
    },
    removeEventListeners() {
      const modelViewer = this.$refs.modelViewer;
      modelViewer.removeEventListener('touchmove', this.preventScroll);
      modelViewer.removeEventListener('wheel', this.preventScroll);
    },
    preventScroll(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    onModelLoad() {
      console.log('Model has been loaded');
      const modelViewer = document.querySelector('body');
      modelViewer.addEventListener('contextmenu', (e) => {
        e.preventDefault(); // 禁用右键菜单（包括长按）
      });
      // 阻止非 <model-viewer> 区域的触摸事件传播
      modelViewer.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      });

      modelViewer.addEventListener('touchmove', (e) => {
        e.stopPropagation();
      });

      modelViewer.addEventListener('touchend', (e) => {
        e.stopPropagation();
      });
      // You can perform other actions here when the model is loaded
    },
    init() {
      this.name = this.getUrl(window.location.href).colUrl
    },
    getUrl(url){
      let arr = url.split('?');
      let params = arr[1].split('&');
      let obj = {};
      for(let i=0;i<params.length;i++){
        let param = params[i].split('=');
        obj[param[0]] = param[1];
      }
      return obj;
    },
  },
}
</script>
<style scoped lang="scss">

</style>
